import React from "react";
import { EyeOff, Lock, Eye } from "lucide-react";
import { PAGE_STATES } from "../hooks/useUserPermissionConfig";

const OPTION_META = {
  [PAGE_STATES.HIDDEN]: { Icon: EyeOff, color: "#64748b" },
  [PAGE_STATES.LOCKED]: { Icon: Lock, color: "#d97706" },
  [PAGE_STATES.FULL]: { Icon: Eye, color: "#059669" },
};

/**
 * 3-state page visibility control: Hidden / Visible·Locked / Full Access.
 * Laid out with a plain flex row, so under document.dir=rtl (Arabic) the
 * segment order mirrors automatically — no manual re-ordering needed.
 */
const SegmentedControl = ({ value, onChange, theme, t, disabled = false }) => {
  const options = [
    { state: PAGE_STATES.HIDDEN, label: t.stateHidden },
    { state: PAGE_STATES.LOCKED, label: t.stateLocked },
    { state: PAGE_STATES.FULL, label: t.stateFull },
  ];

  return (
    <div
      role="radiogroup"
      style={{
        display: "inline-flex",
        padding: "3px",
        borderRadius: "12px",
        gap: "2px",
        background: theme === "dark" ? "rgba(148,163,184,0.12)" : "rgba(15,23,42,0.05)",
        border: theme === "dark"
          ? "1px solid rgba(148,163,184,0.15)"
          : "1px solid rgba(15,23,42,0.06)",
        opacity: disabled ? 0.55 : 1,
      }}
    >
      {options.map(({ state, label }) => {
        const { Icon, color } = OPTION_META[state];
        const active = value === state;
        return (
          <button
            key={state}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            onClick={(e) => { e.stopPropagation(); if (!disabled && !active) onChange?.(state); }}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "7px 12px",
              borderRadius: "9px",
              border: "none",
              cursor: disabled ? "not-allowed" : "pointer",
              fontSize: "12.5px",
              fontWeight: active ? 700 : 500,
              fontFamily: "inherit",
              whiteSpace: "nowrap",
              transition: "all 0.22s ease",
              color: active
                ? color
                : theme === "dark" ? "#94a3b8" : "#64748b",
              background: active
                ? (theme === "dark" ? "rgba(15,23,42,0.9)" : "#ffffff")
                : "transparent",
              boxShadow: active ? "0 2px 8px rgba(0,0,0,0.12)" : "none",
            }}
          >
            <Icon size={14} />
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
